export default __webpack_public_path__ + "static/media/BAKE-BUSD.d5564f2c.png";